import React from 'react'
import Member from '../components/members/Member'

const Members = ({setHide=(()=>{alert("s")})}) => {
    return (
  <Member setHide={setHide}/>
    )
}

export default Members